import React from "react";
import styles from "./Accordion.module.sass";

const Accordion = ({ title, children, showContent, setShowContent }) => {
  return (
    <>
      <div
        className={styles.Title + (showContent ? ` ${styles.Open}` : "")}
        onClick={setShowContent}
      >
        <h3>{title}</h3>
        <i
          className={`${
            showContent ? "icon icon-seta-cima-p" : "icon icon-seta-baixo-p"
          } ${styles.Icon} ${showContent ? styles.IconSelected : ""}`}
        />
      </div>
      <div className={`${styles.Content} ${showContent ? styles.Display : ""}`}>
        {children}
      </div>
    </>
  );
};

export default Accordion;
